<template>
  <div class="page-signin-to-code">
    <Spin :spinning="spinning" :tip="tip"></Spin>
  </div>
</template>

<script>

// import router from '@/router'
import { Spin } from 'ant-design-vue'

export default {
  name: 'SignToCode',
  components: {
    Spin
  },
  data () {
    return {
      spinning: true,
      tip: '登录中...'
    }
  },
  computed: {
    routeQuery () {
      return this.$route.query
    }
  },
  created () {
  },
  methods: {},
  mounted () {
    const { redirect, code, ...otherQuery } = this.routeQuery
    if (!code) {
      this.$router.replace({ path: redirect || '/', query: otherQuery })
      return
    }
    this.$store.dispatch('doLogin', {
      feiXiangCode: code
    }).finally(_ => {
      this.spinning = false
      this.$router.replace({ path: redirect || '/', query: otherQuery })
    }).catch(err => {
      if (err.code === 2002 && err.message === 'HiLeia服务已过期') {
        this.$message.error(err.message)
      } else {
        this.$message.error(err.message)
      }
      console.error(err)
    })
  },
  beforeDestroy () {
  }
}
</script>

<style scoped lang="less">
.page-signin-to-code {
  width: 100%;
  height: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
}
</style>
